import moment from 'moment'
import { getAction } from '@/api/request'

export const NewsMixin = {
  data () {
    return {
      articles: [],
      article: {},
      tmpArticles: [],
      pagination: {
        pageSize: 24,
        currentPage: 1,
        total: 0
      },
    }
  },
  filters: {
    formatDate (item) {
      moment.locale('zk-cn')
      return moment(item.length == 13 ? item : item * 1000).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    openNewPage (item) {
      window.open(item.article, '_blank')
    },
    async loadData () {
      let wx_articles = await this.$api.json('app_msg_list')
      wx_articles.sort((o1, o2) => o2.create_time - o1.create_time)
      this.articles = wx_articles.map(item => {
        let obj = {}
        obj.id = item.aid
        obj.img = item.cover
        obj.date = item.create_time
        obj.article = item.link
        obj.title = item.title
        return obj
      })
      this.article = this.articles[0]
      this.tmpArticles = this.articles
      this.initPagination(this.tmpArticles)
      this.handleCurrentChange(1)
    },
    getArticles () {
      this.loadArticles()
    },
    loadArticles () {
      this.loadData()
      getAction('/apis/articles').then(res => {
        if (res) {
          this.articles = res.sort((o1, o2) => o2.date - o1.date)
          this.article = this.articles[0]
          this.tmpArticles = this.articles
          this.initPagination(this.tmpArticles)
          this.handleCurrentChange(1)
        }
      })
    },
    initPagination (articles) {
      this.pagination = {
        pageSize: 12,
        currentPage: 1,
        total: articles.length
      }
    },
    handleCurrentChange (page) {
      let begin = (page - 1) * this.pagination.pageSize
      let end = page * this.pagination.pageSize
      //分页
      let art = this.tmpArticles.slice(begin, end)
      this.articles = art
    }
  }
}
